var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMelodico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "480.000000pt",
    height: "187.000000pt",
    viewBox: "0 0 480.000000 187.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,187.000000) scale(0.100000,-0.100000)",
    fill: "#FFE500",
    stroke: "#FFE500",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365 1157 c-3 -7 -4 -122 -3 -257 3 -223 5 -245 20 -248 16 -3 18 14 20 215 l3 217 105 -179 c58 -98 110 -180 115 -182 6 -1 57 79 115 179 l105 181 3 -216 c2 -209 3 -217 22 -217 19 0 20 8 20 260 0 241 -1 260 -17 260 -13 0 -51 -58 -127 -190 -60 -105 -113 -193 -117 -195 -4 -3 -58 83 -120 190 -103 180 -132 216 -144 182z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065 1160 c-15 -25 13 -30 171 -30 157 0 164 1 164 20 0 19 -7 20 -164 20 -99 0 -167 -4 -171 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560 910 l0 -260 165 0 c158 0 165 1 165 20 0 19 -7 20 -150 20 l-150 0 0 240 c0 207 -2 240 -15 240 -13 0 -15 -36 -15 -260z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2576 1161 c-16 -25 9 -31 126 -31 137 0 181 -10 234 -53 48 -40 74 -98 74 -167 0 -70 -26 -127 -76 -168 -52 -43 -89 -52 -216 -52 l-108 0 0 110 c0 104 -1 110 -20 110 -20 0 -20 -5 -18 -127 l3 -128 135 0 c158 0 190 9 259 71 77 69 101 172 65 277 -18 52 -84 119 -142 145 -46 20 -305 31 -316 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3180 910 c0 -253 1 -260 20 -260 19 0 20 7 20 260 0 253 -1 260 -20 260 -19 0 -20 -7 -20 -260z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3520 1155 c-103 -33 -170 -129 -170 -245 0 -160 122 -271 284 -258 59 5 137 35 151 59 16 25 -13 27 -59 4 -87 -44 -208 -29 -273 34 -87 83 -85 239 4 323 66 63 182 77 269 33 46 -23 75 -21 59 4 -29 47 -181 74 -265 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4050 1161 c-45 -14 -84 -39 -116 -73 -54 -57 -69 -95 -69 -178 0 -83 15 -121 69 -178 68 -73 185 -101 283 -68 230 76 233 413 5 490 -48 17 -129 20 -172 7z m191 -57 c27 -15 60 -44 76 -68 25 -37 28 -49 28 -127 0 -78 -3 -90 -28 -126 -85 -123 -283 -126 -374 -6 -80 107 -43 270 77 331 65 32 156 31 221 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074 1136 c-99 -46 -164 -162 -149 -264 22 -152 165 -255 310 -225 101 22 175 93 201 195 54 207 -166 385 -362 294z m185 -197 c28 -51 -15 -119 -75 -119 -68 0 -107 78 -65 132 12 15 31 28 44 30 33 6 80 -15 96 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 915 c0 -13 26 -15 170 -15 144 0 170 2 170 15 0 13 -26 15 -170 15 -144 0 -170 -2 -170 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065 680 c-15 -25 13 -30 171 -30 157 0 164 1 164 20 0 19 -7 20 -164 20 -99 0 -167 -4 -171 -10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelodico);
export default __webpack_public_path__ + "static/media/melodico.9651dac45e1dd8a44af0cf3f10fd808a.svg";
export { ForwardRef as ReactComponent };